import React from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import POSIconButton from '../POSIconButton';
import { NavigationOptions } from 'swiper/types/components/navigation';

import 'swiper/swiper.less';
import './POSSwiper.less';

SwiperCore.use([Navigation]);

export interface Props extends Swiper {
  slides: React.ReactNode[];
}

export const POSSwiper = (props: Props) => {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  return (
    <Swiper
      spaceBetween={10}
      slidesPerView={4}
      navigation={{
        prevEl: navigationPrevRef.current,
        nextEl: navigationNextRef.current,
      }}
      onInit={(swiper) => {
        if (swiper.params?.navigation) {
          (swiper.params.navigation as NavigationOptions).prevEl =
            navigationPrevRef.current;
          (swiper.params.navigation as NavigationOptions).nextEl =
            navigationNextRef.current;
        }

        swiper.navigation.update();
      }}
      freeMode
      className="pos-swiper"
      {...props}
    >
      <div
        ref={navigationPrevRef}
        className="pos-swiper__nav pos-swiper__nav--prev"
      >
        <POSIconButton iconOnly icon="arrow-left" />
      </div>
      <div
        ref={navigationNextRef}
        className="pos-swiper__nav pos-swiper__nav--next"
      >
        <POSIconButton iconOnly icon="arrow-right" />
      </div>

      {props.slides.map((s, i) => (
        <SwiperSlide key={`slide_${i}`}>{s}</SwiperSlide>
      ))}
    </Swiper>
  );
};
